import { ProductInterface } from 'shared/interfaces/ProductInterface';
import {
    AttributesClassInterface,
    LocalizedAttributeNames,
    ProductAttributes,
    LocalizedAttributesInstance,
} from 'shared/interfaces/AttributesClassInterface';
import { LocalesEnum } from 'shared/enums/LocalesEnum';

export class Product implements ProductInterface {
    public id!: string;

    public label!: string;

    public attributes!: ProductAttributes;

    public constructor(id: string, label: string, attrs: string, public readonly rawName: LocalesEnum) {
        this.id = id;
        this.label = label;
        this.attributes = {
            ...LocalizedAttributesInstance,
            ...JSON.parse(attrs),
            Label: label,
            ID: id,
        };
    }

    public getAttributes(): AttributesClassInterface {
        return Object
            .entries(this.attributes)
            .reduce((acc, [key, val]) => ({
                ...acc,
                [['ID', 'Label'].includes(key) ? key : `_${key}`]: val,
            }), {} as AttributesClassInterface);
    }

    public getRaw(name: LocalizedAttributeNames): string[] {
        const attr = this.attributes[name];
        if (!!attr && typeof attr === 'object') {
            return attr[this.rawName] || [];
        }
        return [];
    }

    public getLocalized(name: LocalizedAttributeNames, locale: LocalesEnum): string[] {
        const attr = this.attributes[name];
        if (!!attr && typeof attr === 'object') {
            const out = attr[locale];
            return out || this.getRaw(name);
        }
        return this.getRaw(name);
    }

    public isSolution(locale: LocalesEnum): boolean {
        // eslint-disable-next-line no-console
        console.log(locale);
        return !!this.id;
    }
}
